import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8b11952"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mx-0 justify-content-center shadow rounded-4 bg-white" }
const _hoisted_2 = { class: "fw-bold fs-6 my-4" }
const _hoisted_3 = { class: "col-lg-9 p-3 p-lg-4 shadow rounded-4 bg-white mb-4 mb-lg-5" }
const _hoisted_4 = { class: "fw-bold fs-6 mb-4" }
const _hoisted_5 = {
  id: "chatBoxContainer",
  class: "col-lg-9 p-3 p-lg-4 shadow rounded-4 bg-white mb-4 mb-lg-5"
}
const _hoisted_6 = { class: "text-center fw-bold fs-6 mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onSubmit"]
const _hoisted_11 = { class: "me-lg-3 me-0 mb-4 mb-lg-0 w-100" }
const _hoisted_12 = {
  key: 0,
  class: "text-danger fs-7 mt-1"
}
const _hoisted_13 = { class: "d-flex justify-content-center mb-5" }

import Breadcrumb from '@/components/breadcrumb/index.vue'
import { translate } from '@/languages/i18n'
import { ACCOUNT_STORE, CHAT_STORE, COMMUNITY_STORE, GROUPS_STORE } from '@/store/constants'
import { ChatStateTypes } from '@/store/modules/chat'
import { computed, ComputedRef, nextTick, onBeforeUnmount, onMounted, ref, watch, watchEffect } from 'vue'
import { onBeforeRouteLeave, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import VirtualList from 'vue3-virtual-scroll-list'
import MessageItem from '@/views/community-admin/groups/components/MessageItem.vue'
import Button from '@/components/button/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import DeleteChatModal from '@/views/user/conversations/components/DeleteChatModal.vue'
import DeleteChatSuccessModal from '@/views/user/conversations/components/DeleteChatSuccessModal.vue'
import ModalUpdateStatusChat from '@/views/community-admin/groups/components/ModalUpdateStatusChat.vue'
import ModalUpdatePrivateSuccess from '@/views/community-admin/groups/components/ModalUpdatePrivateSuccess.vue'
import ModalUpdatePublicSuccess from '@/views/community-admin/groups/components/ModalUpdatePublicSuccess.vue'
import Loading from '@/components/loading/index.vue'
//validate
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useWebSocket } from '@/use/useWebsocket'
import router from '@/router'
import TargetTag from '@/components/target-tag/index.vue'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { HANDLE_USERS_MENTION, numberWithCommas } from '@/constants/common'
import { checkLimitMention, customMaxLengthTextMention, customMinLength, isSaasTypePool } from '@/utils'
import MentionTextarea from '@/components/mention-textarea/index.vue'
import { useChat } from '@/composables/chat'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const debugLog = (...args: any[]) => {
  console.info('[TalkRoomsVirtualList]', ...args)
}

const { setTimeoutScroll } = useChat()
const route = useRoute()
const store = useStore()
const loading = ref<boolean>(false)
const mentionReady = ref(null)
const { connection } = useWebSocket('talkChannel')
const virtual_list = ref()
const talk_room_data = computed<ComputedRef<Pick<ChatStateTypes, 'talk_room'>>>(() => store.getters[CHAT_STORE.GETTERS.TALK_ROOM])
const message = computed(() => store.getters[CHAT_STORE.GETTERS.GET_MESSAGE_SOCKET])
const users = computed(() => store.getters[GROUPS_STORE.GETTERS.LIST_MENTION_USER])
const listUserShow = computed(() => store.getters[ACCOUNT_STORE.GETTERS.LIST_USER_WITH_DELETED])
const page = computed(() => store.getters[CHAT_STORE.GETTERS.PAGE_CHAT])
const loadingChat = computed(() => store.getters[CHAT_STORE.GETTERS.LOADING_CHAT])
const storeSaasType = computed(() => store.getters[COMMUNITY_STORE.GETTERS.GET_SAAS_TYPE])
const dataLoadMore = ref()
const disableSubmit = ref(false)
const idComment = ref(null)
const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('groupManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('listGroup'),
    to: `/community/communities/${route.params?.id}/admin/groups?created_at=desc`,
    active: false,
  },
  {
    content: translate('listTalkrooms'),
    to: `/community/communities/${route.params?.id}/admin/groups/${route.params?.group_id}/talkrooms`,

    active: false,
  },
  {
    content: translate('talkRoomDetail'),
    to: '',
    active: true,
  },
]

const mentionComponent = ref<{ clear: () => void } | null>(null)
const errorOccurred = ref(false)

const rules = computed(() => {
  return {
    content: {
      // required,
      maxLength: (value: string) => customMaxLengthTextMention(value, 500, formData.value.mention_user_ids, users.value?.data, formData.value.rawContent),
      // minLength: (value: string) => customMinLength(value, DEFAULT_MIN_LENGTH),
      limitMention: (value: string) => checkLimitMention(value, formData.value.mention_user_ids),
      errorOccurred: () => !errorOccurred.value,
    },
  }
})

const formData = ref({
  content: '',
  mention_user_ids: [],
  rawContent: '',
})
const handleClickBack = (): MouseEvent<'click'> => {
  router.push(route.path.split('/').slice(0, -1).join('/'))
}

const v1$ = useVuelidate(rules, formData)
const sendMessage = ref(false)

const onSubmit = async () => {
  disableSubmit.value = true
  v1$.value.$touch()

  isCheckedNGKeyContent.value = false
  await checkNGKey()
  while (!isCheckedNGKeyContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (v1$.value.$invalid || ngContent.value || errorOccurred.value) {
    disableSubmit.value = false
    return
  }

  await store.dispatch(CHAT_STORE.ACTIONS.SEND_MESSAGE_TALK_ROOM, {
    talkroom_id: route.params?.talkroom_id,
    content: {
      content: formData.value.content,
      create_by_admin: true,
      mention_user_ids: formData.value.mention_user_ids,
    },
  })
  sendMessage.value = true
  v1$.value.$reset()
  mentionComponent.value?.clear()
  Object.assign(formData.value, {
    content: '',
    mention_user_ids: [],
  })
  disableSubmit.value = false
}

const changeContent = async (content: any) => {
  v1$.value.content.$model = content.content
  formData.value.mention_user_ids = content.mentionedUserIds
  formData.value.rawContent = content.rawContent
  await checkNGKey()
}

const getListUserMention = async () => {
  mentionReady.value = false

  if (storeSaasType.value && !isSaasTypePool(storeSaasType.value)) {
    await store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_MENTION_USER, {
      group_id: route.params?.group_id,
      talk_room_id: route.params?.talkroom_id,
      params: {
        create_by_admin: true,
      },
    })
  }

  mentionReady.value = true
}

const checkErrorOccurred = (error: boolean) => {
  errorOccurred.value = error
}

const getListUserCommunity = async () => {
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_USER_WITH_DELETED, route?.params?.id)
}
watch(
  () => message.value,
  () => {
    if (message.value?.type === 'delete') {
      store.dispatch(CHAT_STORE.ACTIONS.REMOVE_MESSAGE_TALK_ROOM, message.value.id)
    }
    if (message.value?.type === 'create' && message.value?.talkroom_id === route.params?.talkroom_id) {
      store.dispatch(CHAT_STORE.ACTIONS.RECEIVE_MESSAGE_TALK_ROOM, message.value)
    }
    if (message.value?.type === 'update') store.commit(CHAT_STORE.MUTATIONS.UPDATE_STATUS_MESSAGE, message.value)
  },
  {
    deep: true,
  }
)

watchEffect(() => {
  dataLoadMore.value = talk_room_data.value?.talk_room?.chat
  debugLog('dataLoadMore recomputed', {
    chatLength: talk_room_data.value?.talk_room?.chat?.length ?? 0,
    hasDataLoadMore: Boolean(dataLoadMore.value),
  })
  dataLoadMore.value.unshift({ id: 'first_chat_page' })
})

const getData = ref<boolean>(false)

onMounted(async () => {
  idComment.value = route.query?.target_content_id
  if (route.params?.talkroom_id) {
    loading.value = true
    await store.dispatch(CHAT_STORE.ACTIONS.GET_TALK_ROOM, {
      id: route.params?.talkroom_id,
      params: {
        create_by_admin: true,
        change: true,
        target_content_id: idComment.value,
      },
    })

    await getListUserMention()
    await getListUserCommunity()
    getData.value = true
    loading.value = false
  }
})

const stopScroll = ref(false)

const handleScrollerScroll = (event: Event) => {
  const target = event.target as HTMLElement | null
  debugLog('scroller scroll event', {
    scrollTop: target?.scrollTop ?? null,
    scrollHeight: target?.scrollHeight ?? null,
    clientHeight: target?.clientHeight ?? null,
  })
}

const scrollMessage = async (scroller: Element, scrollTop: number) => {
  debugLog('scrollMessage invoked', {
    hasTargetComment: Boolean(idComment.value),
    stopScroll: stopScroll.value,
    requestedScrollTop: scrollTop,
    sendMessage: sendMessage.value,
  })
  if (idComment.value && !stopScroll.value) {
    stopScroll.value = true
    const element = document.getElementById(idComment.value) as HTMLElement | null
    if (element) {
      while (!mentionReady.value) {
        await new Promise((resolve) => setTimeout(resolve, 500))
      }

      const elementPosition = element.offsetTop - scroller.offsetTop
      debugLog('scrollMessage scrolling to target element', {
        elementId: idComment.value,
        elementPosition,
      })
      scroller.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      })

      setTimeoutScroll(element)
      debugLog('scrollMessage targeted scroll dispatched')
    }
  } else {
    scroller.scrollTop = scrollTop
    sendMessage.value = false
    debugLog('scrollMessage fallback scroll applied', {
      appliedScrollTop: scrollTop,
    })
  }
}

watch(
  () => talk_room_data?.value.talk_room.chat,
  async () => {
    await nextTick()
    debugLog('chat watcher triggered', {
      page: page.value,
      chatLength: talk_room_data.value?.talk_room?.chat?.length ?? 0,
      sendMessage: sendMessage.value,
    })
    if (page.value === 1) {
      // not use function scrollToBottom from virtual_list may cause infinite loop
      // await virtual_list.value?.scrollToBottom()
      virtual_list.value.scrollTop = 9999999999
      const scroller = document.querySelector('.scroller')
      if (scroller) {
        debugLog('chat watcher scrollToBottom executed')
        scrollMessage(scroller, 9999999999)
      }
    } else {
      virtual_list.value.scrollTop = 8000
      const scroller = document.querySelector('.scroller')
      if (scroller) {
        debugLog('chat watcher scrollTo previous messages', {
          scrollTop: sendMessage.value ? 9999999999 : 8000,
        })
        scrollMessage(scroller, sendMessage.value ? 9999999999 : 8000)
      }
    }
  },
  {
    deep: true,
  }
)

watchEffect(() => {
  if (!Object.keys(talk_room_data.value?.talk_room?.header).length && getData.value) {
    router.replace(`/community/communities/${route.params?.id}/admin/groups/${route.params?.group_id}/talkrooms`)
  }
})

onMounted(() => {
  const scroller = document.querySelector('.scroller') as HTMLElement | null
  virtual_list.value = scroller
  if (scroller) {
    debugLog('scroller mounted', {
      scrollHeight: scroller.scrollHeight,
      clientHeight: scroller.clientHeight,
    })
    scroller.addEventListener('scroll', handleScrollerScroll, { passive: true })
  } else {
    debugLog('scroller mounted: element not found')
  }
})

onBeforeUnmount(() => {
  const scroller = virtual_list.value as HTMLElement | null
  // Safe check: scroller not null and has function removeEventListener
  if (scroller && typeof scroller.removeEventListener === 'function') {
    scroller.removeEventListener('scroll', handleScrollerScroll)
  }
  // clear ref when unmount
  virtual_list.value = null
})

const isCheckedNGKeyContent = { value: false }
const ngContent = ref(false)
const checkNGKey = debounce(async () => {
  const queryData = { sentence: v1$.value.content.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngContent.value = data.data.data.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyContent.value = true
  }
})

onBeforeRouteLeave(() => {
  store.dispatch(CHAT_STORE.ACTIONS.SET_PAGE_CHAT, 1)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(translate)('talkRoomDetail')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(talk_room_data).talk_room?.header.group_name), 1),
        _createVNode(TargetTag, {
          class: "mb-4 fs-8 text-break break-spaces",
          data: _unref(talk_room_data).talk_room?.header.group_information
        }, null, 8, ["data"]),
        _createElementVNode("p", null, "参加者：" + _toDisplayString(_unref(numberWithCommas)(_unref(talk_room_data)?.talk_room?.header?.group_members_number)) + "名", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(talk_room_data).talk_room?.header.talk_room_name), 1),
        _createVNode(TargetTag, {
          class: "mb-4 fs-8 text-center border-bottom pb-4",
          data: _unref(talk_room_data).talk_room?.header.talk_room_information
        }, null, 8, ["data"]),
        (_unref(loadingChat))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          : _createCommentVNode("", true),
        _createVNode(_unref(VirtualList), {
          class: "scroller px-4",
          ref: (_value, _refs) => {
            _refs['virtual_list'] = _value
            virtual_list.value = _value
          },
          style: {"height":"540px","overflow-y":"auto","overflow-x":"hidden","overflow-anchor":"none !important"},
          "estimate-size": 200,
          keeps: 40,
          start: 14,
          "data-key": 'id',
          "data-sources": dataLoadMore.value,
          "data-component": MessageItem,
          "extra-props": { users: _unref(listUserShow), id_comment: idComment.value }
        }, null, 8, ["data-sources", "extra-props"]),
        _createElementVNode("form", {
          onSubmit: _withModifiers(onSubmit, ["prevent"]),
          action: "",
          class: "bg-gray p-3 d-flex flex-column flex-lg-row align-items-center form-chat"
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(MentionTextarea, {
              users: _unref(HANDLE_USERS_MENTION)(_unref(users)?.data, _unref(listUserShow)),
              "class-name": ['form-control p-2', _unref(v1$).content.$error ? 'is-invalid' : ''],
              "title-mention": _unref(translate)('titleMentionTalkRoomAdmin'),
              onContent: changeContent,
              onGetListUserMention: getListUserMention,
              onCheckErrorOccurred: checkErrorOccurred,
              ref: (_value, _refs) => {
                _refs['mentionComponent'] = _value
                mentionComponent.value = _value
              }
            }, null, 8, ["users", "class-name", "title-mention"]),
            (ngContent.value && !_unref(v1$).content.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
              : _createCommentVNode("", true),
            _createVNode(InputErrorMessage, {
              title: _unref(translate)('chatContent'),
              validator: _unref(v1$).content.$errors[0]?.$validator,
              params: [_unref(DEFAULT_MIN_LENGTH), 500]
            }, null, 8, ["title", "validator", "params"])
          ]),
          _createVNode(Button, {
            title: _unref(translate)('SO65send'),
            disabled: _unref(v1$).$invalid || disableSubmit.value || !formData.value.content.trim(),
            type: 'secondary',
            htmlType: 'submit',
            class: "fw-bold mt-2"
          }, null, 8, ["title", "disabled"])
        ], 40, _hoisted_10)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(Button, {
          title: _unref(translate)('back'),
          type: 'secondary',
          onClick: handleClickBack,
          className: 'fw-bold'
        }, null, 8, ["title"])
      ])
    ]),
    _createVNode(Loading, { loading: loading.value }, null, 8, ["loading"]),
    _createVNode(DeleteChatModal, {
      isTalkRoom: true,
      title: "deleteTalk"
    }),
    _createVNode(DeleteChatSuccessModal, { title: "deleted" }),
    _createVNode(ModalUpdateStatusChat),
    _createVNode(ModalUpdatePrivateSuccess),
    _createVNode(ModalUpdatePublicSuccess)
  ], 64))
}
}

})